"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WanikaniDashboard = void 0;

var _react = _interopRequireDefault(require("react"));

var _kyouElements = require("kyou-elements");

var _WanikaniStatus = require("./WanikaniStatus");

var _WanikaniLevelProgression = require("./WanikaniLevelProgression");

var _WanikaniCarousel = require("./WanikaniCarousel");

var _useWanikaniStatus = require("./useWanikaniStatus");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const WanikaniDashboard = () => {
  const {
    isLoading,
    levelStatus
  } = (0, _useWanikaniStatus.useWanikaniStatus)();
  return /*#__PURE__*/_react.default.createElement(_kyouElements.DashboardLayout, null, /*#__PURE__*/_react.default.createElement(_kyouElements.Row, {
    size: 2
  }, /*#__PURE__*/_react.default.createElement(_kyouElements.Panel, null, /*#__PURE__*/_react.default.createElement(_WanikaniStatus.WanikaniStatus, {
    isLoading: isLoading,
    levelStatus: levelStatus
  }))), /*#__PURE__*/_react.default.createElement(_kyouElements.Row, {
    size: 10
  }, /*#__PURE__*/_react.default.createElement(_kyouElements.Panel, null, /*#__PURE__*/_react.default.createElement(_WanikaniCarousel.WanikaniCarousel, {
    isLoading: isLoading,
    levelStatus: levelStatus
  })), /*#__PURE__*/_react.default.createElement(_kyouElements.Column, null, /*#__PURE__*/_react.default.createElement(_kyouElements.Panel, {
    title: "days per level"
  }, /*#__PURE__*/_react.default.createElement(_WanikaniLevelProgression.WanikaniLevelProgression, null)), /*#__PURE__*/_react.default.createElement(_kyouElements.Panel, {
    title: "more coming soon..."
  }))));
};

exports.WanikaniDashboard = WanikaniDashboard;